module.exports = __webpack_public_path__ + "img/weissrotoben.ecce3511.jpg";